import React from 'react';
import { Col, Container, Row } from 'react-bootstrap';

const Skills = () => {
    return (
        <div>
            <Container className="py-5" id="skills">
                <Row>
                    <Col sm={12} md={4}>
                        <h3>Skills</h3>
                        <p>I am inspired by creating great work with people who are as passionate as I am about building something awesome.</p>
                    </Col>
                    <Col sm={12} md={8}>
                        <div className="row g-3">

                            <div className="card  p-3 col-md-6">
                                <h4>Frontend Development</h4>
                                <p>HTML, CSS, JS, SASS, Bootstrap, Wordpress, Ionic, Foundation, React.js.</p>
                            </div>
                            <div className="card  p-3 col-md-6" >
                                <h4>Web Development</h4>
                                <p>Javascript, Node.js, EXPRESSJS, PHP, MongoDB, Redix, PostgreSQL, Vs-code.</p>
                            </div>
                            <div className="card  p-3 col-md-6">
                                <h4>UI\UX Design</h4>
                                <p>Photoshop, Figma, Usability Testing.</p>
                            </div>
                            <div className="card  p-3 col-md-6">
                                <h4>Consulting & SEO Audit</h4>
                                <p>Screaming Frog, Woorank, Raventools, Semrush, Moz, WebCEO, Google Analytics, ChartBeat, CrazyEgg.</p>
                            </div>

                        </div>

                    </Col>
                </Row>

            </Container>
        </div>
    );
}

export default Skills;
